import { AppStateEnum } from '../../../../../main/types/app-state.types.ts';

import { StepGraderType } from '../../../../constants/grading.ts';

import { UserSayBaseStateChangeHandlerUtil } from './user-say-base.handler.ts';

/**
 * Handler for rhyme sound pronunciation tasks
 * Specialized for the UserSayRhymeSound step type in Rhyming tasks
 * Uses phoneme pronunciation grader for evaluating single sounds
 */
export class UserSayRhymeSoundStateChangeHandlerUtil extends UserSayBaseStateChangeHandlerUtil {
  private static _instance: UserSayRhymeSoundStateChangeHandlerUtil;

  static get instance(): UserSayRhymeSoundStateChangeHandlerUtil {
    if (!UserSayRhymeSoundStateChangeHandlerUtil._instance) {
      UserSayRhymeSoundStateChangeHandlerUtil._instance = new UserSayRhymeSoundStateChangeHandlerUtil();
    }
    return UserSayRhymeSoundStateChangeHandlerUtil._instance;
  }

  protected getHandlerName(): string {
    return 'UserSayRhymeSound';
  }

  /**
   * Determines the next state based on task and step type
   * Rhyme sound steps typically go directly to Recording
   */
  protected override async determineNextState(): Promise<AppStateEnum | null> {
    return Promise.resolve(AppStateEnum.Recording);
  }

  protected getGraderType(): StepGraderType {
    return StepGraderType.RHYME_SOUND;
  }
}

export const getUserSayRhymeSoundStateChangeHandlerUtil = (): UserSayRhymeSoundStateChangeHandlerUtil =>
  UserSayRhymeSoundStateChangeHandlerUtil.instance;
